module.exports = __webpack_public_path__ + "img/5.a17c1124.jpg";